export const initialFormState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
  error: false,
  errorMsg: "",
  loading: false,
  success: false,
};
